import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCancelReason,
  cancelCODOrder,
  addBankAccount,
  getAllBanks,
  getMyAccountBank,
  checkIfUserHasBankAccount
} from "services/user/userService";
import "./CancelOrder.scss";
import Swal from "sweetalert2";
import { PacmanLoader } from "react-spinners";

const CancelOrder = () => {
  const [selectedReasonID, setSelectedReason] = useState("");
  const [hasBankAccount, setHasBankAccount] = useState(null);
  const token = localStorage.getItem("token");
  const [accountBankInfor, setAccountBankInfor] = useState({
    bankID: "",
    bankName: "",
    bankShortName: "",
    accountNumber: "",
    accountName: "",
  });
  const [banks, setAllBanks] = useState(null);

  const [reasons, setReasons] = useState(null);

  const location = useLocation();
  const { orderID, orderPaymentStatus } = location.state || {};
  const navigate = useNavigate();
  const [myAccountBank, setMyAccountBank] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function fetchBankDetails() {
      console.log("orderID", orderID);
      console.log("trả tiền ch", orderPaymentStatus);

      const response = await checkIfUserHasBankAccount(token);
      if (response) {
        setHasBankAccount(response.data);
      }
      console.log(hasBankAccount);
    }

    fetchBankDetails();
  }, []);

  useEffect(() => {
    console.log("Selected Reason has been updated:", selectedReasonID);
    console.log("Additional Info:", accountBankInfor);
    console.log("có tk:", hasBankAccount === false);
    console.log("my Info:", myAccountBank);
  }, [selectedReasonID]);

  useEffect(() => {
    async function fetchReason() {
      try {
        const response = await getCancelReason(token);
        setReasons(response.data);
        if (hasBankAccount === false) {
          console.log("có tk chua:", hasBankAccount === false);
          try {
            const response2 = await getAllBanks();
            setAllBanks(response2.data);
            console.log("banks", banks);
          } catch (error) {
            console.error("Lỗi khi lấy danh sách ngân hàng:", error);
          }
        } 
          
      } catch (error) {
        console.error("Lỗi khi lấy lý do hủy:", error);
      }
    }
    fetchReason();
  });


  useEffect(() => {
    if (hasBankAccount) {
      async function fetchBankAccountData() {
        try {
          const bankAccountData = await getMyAccountBank(token);
          setMyAccountBank(bankAccountData.data);
        } catch (error) {
          console.error("Lỗi khi lấy tài khoản ngân hàng:", error);
        }
      }
  
      fetchBankAccountData();
    }
  }, [hasBankAccount, token]); // Chạy lại khi `hasBankAccount` hoặc `token` thay đổi
  

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setAccountBankInfor((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedReasonID) {
      Swal.fire({
        icon: "error",
        title: "Bạn chưa chọn lí do hủy!",
        confirmButtonText: "Đóng",
      });
      return;
    }

  

    try {
      setIsLoading(true)

      if (hasBankAccount === false && orderPaymentStatus === "Đã thanh toán") {
        const { bankID, bankName, bankShortName, accountNumber, accountName } =
          accountBankInfor;
        const responseAdd = await addBankAccount(
          token,
          bankID,
          bankName,
          bankShortName,
          accountNumber,
          accountName
        );
        if (responseAdd.status !== 200) {
          Swal.fire({
            icon: "error",
            title: "Có lỗi xảy ra khi lưu thông tin hoàn tiền!",
            confirmButtonText: "Đóng",
          });
        }
      }

      const response = await cancelCODOrder(token, orderID, selectedReasonID);
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          // title: "Bạn đã hủy đơn thành công!",
          text: "Bạn đã hủy đơn thành công!",
          timer: 5000,
          timerProgressBar: true,
          showConfirmButton: false,
          customClass: {
            popup: "my-swal", // Liên kết với lớp CSS
          },
        }).then(() => {
          navigate("/");
        });
      }
    } catch (error) {

    } finally {
      setIsLoading(false)
    }
    

    console.log("Reason:", selectedReasonID);
    console.log("Additional Info:", accountBankInfor);
  };

  const handleBankSelect = (selectedBank) => {
    setAccountBankInfor({
      ...accountBankInfor,
      bankName: selectedBank.name,
      bankShortName: selectedBank.short_name,
      bankID: selectedBank.id,
      accountNumber: "",
      accountName: "",
    });
  };

  const handleBankSelectChange = (event) => {
    const selectedBankName = event.target.value;
    const selectedBank = banks.find((bank) => bank.name === selectedBankName);
    setAccountBankInfor((prev) => ({
      ...prev,
      bankName: selectedBankName,
      bankShortName: selectedBank?.shortName || "", 
    }));
  };
  

  return (
    <div className="wrapper-container">
      <div className="cancel-order-container">
        <form className="cancel-order-form" onSubmit={handleSubmit}>
          <div className="chooseReason-container">
            <div className="chooseReason">
              <h4 className="chooseReason-title">Lý do hủy đơn hàng</h4>
              {Array.isArray(reasons) && reasons.length > 0 ? (
                reasons.map((item) => (
                  <div key={item.id} className="address-item">
                    <label className="reason-label">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="reason"
                        value={item.reason}
                        onChange={() => setSelectedReason(item.id)}
                      />
                      {item.reason}
                    </label>
                  </div>
                ))
              ) : (
                <p>Loading reasons...</p> // Hiển thị thông báo khi dữ liệu chưa sẵn sàng
              )}
            </div>
          </div>
          {orderPaymentStatus === "Đã thanh toán" ? (
            hasBankAccount === false ? (
              <div className="bank-details">
                <h4 className="bank-details-title">
                  Nhập thông tin tài khoản ngân hàng để được hoàn tiền
                </h4>

                {banks && banks.length > 0 ? (
                  <div className="bank-logos-container">
                    {Array(20)
                      .fill()
                      .map((_, index) => (
                        <div
                          key={index}
                          className="bank-logo-item"
                          onClick={() =>
                            handleBankSelect(banks[index % banks.length])
                          }
                        >
                          <img
                            src={banks[index % banks.length]?.logo}
                            alt={`Bank ${index + 1}`}
                          />
                        </div>
                      ))}
                  </div>
                ) : (
                  <p>Không có danh sách ngân hàng để hiển thị.</p>
                )}

<label className="input-label">
  Tên ngân hàng:
  <select
    className="input-field"
    name="bankName"
    value={accountBankInfor.bankName}
    onChange={handleBankSelectChange}
  >
    <option value="">-- Chọn ngân hàng --</option>
    {banks && banks.length > 0
      ? banks.map((bank, index) => (
          <option key={index} value={bank.name}>
            {bank.name}
          </option>
        ))
      : (
        <option value="" disabled>
          Đang tải danh sách ngân hàng...
        </option>
      )}
  </select>
</label>


                <label className="input-label">
                  Tên ngắn gọn:
                  <input
                    className="input-field"
                    type="text"
                    name="bankShortName"
                    value={accountBankInfor.bankShortName}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="input-label">
                  Số tài khoản:
                  <input
                    className="input-field"
                    type="text"
                    name="accountNumber"
                    value={accountBankInfor.accountNumber}
                    onChange={handleInputChange}
                  />
                </label>

                <label className="input-label">
                  Tên tài khoản:
                  <input
                    className="input-field"
                    type="text"
                    name="accountName"
                    value={accountBankInfor.accountName}
                    onChange={handleInputChange}
                  />
                </label>
              </div>
            ) : (
              <p>
                Quá trình hoàn tiền sẽ mất từ 7-10 ngày, chúng tôi sẽ hoàn tiền
                về tài khoản ngân hàng của bạn! <br />
                {myAccountBank ? (
                  <span>
                    {myAccountBank.bankName} - {myAccountBank.bankShortName}
                    <br />
                    STK: {myAccountBank.accountNumber} -{" "}
                    {myAccountBank.accountName}
                  </span>
                ) : (
                  <span>Đang tải thông tin tài khoản...</span>
                )}
              </p>
            )
          ) : null}

          <button className="submit-button" type="submit">
            Hủy đơn
          </button>
        </form>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CancelOrder;
